import { UsersIcon } from "@phosphor-icons/react/dist/csr/Users";
import { Button } from "@volca/ui/components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

interface RecipientEmptyStateProps {
  searchValue: string;
  onClearSearch: () => void;
  hasTeamFilter?: boolean;
  onClearTeams?: () => void;
}

export const RecipientEmptyState = ({
  searchValue,
  onClearSearch,
  hasTeamFilter = false,
  onClearTeams,
}: RecipientEmptyStateProps) => {
  const hasSearch = searchValue.trim().length > 0;

  return (
    <Empty className={emptyStateVariants({ layout: "workspace" })}>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <UsersIcon aria-hidden />
        </EmptyMedia>

        <EmptyTitle>
          {hasSearch
            ? "No technicians match your search"
            : hasTeamFilter
              ? "No technicians match the selected teams"
              : "No technicians found"}
        </EmptyTitle>
        <EmptyDescription>
          {hasSearch
            ? "Try a different technician name."
            : hasTeamFilter
              ? "Select different teams or clear the team filter."
              : "Technicians with ServiceTitan IDs will show up here."}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        {hasTeamFilter && (
          <Button
            type="button"
            size="sm"
            variant="secondary"
            onClick={onClearTeams}
          >
            Clear teams
          </Button>
        )}
        {hasSearch && (
          <Button
            type="button"
            size="sm"
            variant="secondary"
            onClick={onClearSearch}
          >
            Clear search
          </Button>
        )}
      </EmptyContent>
    </Empty>
  );
};
